import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_CONFIG from '../config/api';

const CadastrarLojaModal = ({ onClose, onSuccess, lojaParaEditar = null }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    nome: '',
    codigo: '',
    status: 'ativa',
    endereco: {
      rua: '',
      numero: '',
      bairro: '',
      cidade: '',
      estado: '',
      cep: ''
    },
    contato: {
      telefone: '',
      email: '',
      whatsapp: ''
    },
    dados_empresa: {
      cnpj: '',
      razao_social: '',
      inscricao_estadual: '',
      inscricao_municipal: ''
    },
    financeiro: {
      dia_vencimento: 10,
      valor_mensalidade: 0
    },
    integrador: {
      tipo: 'nenhum',
      url_conexao: '',
      taxa_atualizacao: 'manual',
      horario_atualizacao: '22:00',
      dia_atualizacao: 0,
      ativo: false
    }
  });

  useEffect(() => {
    if (lojaParaEditar) {
      setFormData({
        nome: lojaParaEditar.nome || '',
        codigo: lojaParaEditar.codigo || '',
        status: lojaParaEditar.status || 'ativa',
        endereco: { ...formData.endereco, ...lojaParaEditar.endereco },
        contato: { ...formData.contato, ...lojaParaEditar.contato },
        dados_empresa: { ...formData.dados_empresa, ...lojaParaEditar.dados_empresa },
        financeiro: { ...formData.financeiro, ...lojaParaEditar.financeiro },
        integrador: { ...formData.integrador, ...lojaParaEditar.integrador }
      });
    }
  }, [lojaParaEditar]);

  // Busca automática de CEP
  useEffect(() => {
    const cepLimpo = formData.endereco.cep.replace(/\D/g, '');
    if (cepLimpo.length === 8) {
      buscarCep(cepLimpo);
    }
  }, [formData.endereco.cep]);

  const buscarCep = async (cep) => {
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
      if (response.data.erro) {
        // CEP inexistente
        return;
      }
      
      setFormData(prev => ({
        ...prev,
        endereco: {
          ...prev.endereco,
          rua: response.data.logradouro,
          bairro: response.data.bairro,
          cidade: response.data.localidade,
          estado: response.data.uf,
          cep: prev.endereco.cep // Mantém o CEP digitado (formatado ou não)
        }
      }));
    } catch (error) {
      console.error('Erro ao buscar CEP:', error);
    }
  };

  const handleChange = (e, section = null) => {
    const { name, value } = e.target;
    if (section) {
      setFormData(prev => ({
        ...prev,
        [section]: {
          ...prev[section],
          [name]: value
        }
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      const headers = { 'x-auth-token': token };

      if (lojaParaEditar) {
        await axios.put(`${API_CONFIG.API_URL}/lojas/${lojaParaEditar._id}`, formData, { headers });
      } else {
        await axios.post(`${API_CONFIG.API_URL}/lojas`, formData, { headers });
      }

      onSuccess();
      onClose();
    } catch (error) {
      console.error('Erro ao salvar loja:', error);
      console.error('Erro ao salvar loja:', error.response?.data?.message || error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: 'white',
        padding: '30px',
        borderRadius: '12px',
        width: '90%',
        maxWidth: '800px',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
          <h2 style={{ margin: 0, color: '#2d3748' }}>{lojaParaEditar ? 'Editar Loja' : 'Nova Loja'}</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}>×</button>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
          {/* Dados Básicos */}
          <div style={{ gridColumn: '1 / -1' }}>
            <h3 style={{ fontSize: '16px', color: '#4a5568', borderBottom: '1px solid #e2e8f0', paddingBottom: '8px', marginBottom: '15px' }}>Dados Básicos</h3>
          </div>

          <div className="form-group">
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#4a5568' }}>Nome da Loja *</label>
            <input
              required
              type="text"
              name="nome"
              value={formData.nome}
              onChange={handleChange}
              style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0' }}
            />
          </div>

          <div className="form-group">
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#4a5568' }}>Código (ex: loja02) *</label>
            <input
              required
              type="text"
              name="codigo"
              value={formData.codigo}
              onChange={handleChange}
              disabled={!!lojaParaEditar}
              style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0', background: lojaParaEditar ? '#f7fafc' : 'white' }}
            />
          </div>

          {/* Endereço */}
          <div style={{ gridColumn: '1 / -1', marginTop: '10px' }}>
            <h3 style={{ fontSize: '16px', color: '#4a5568', borderBottom: '1px solid #e2e8f0', paddingBottom: '8px', marginBottom: '15px' }}>Endereço</h3>
          </div>

          <div className="form-group">
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#4a5568' }}>Rua *</label>
            <input required type="text" name="rua" value={formData.endereco.rua} onChange={(e) => handleChange(e, 'endereco')} style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0' }} />
          </div>
          <div className="form-group">
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#4a5568' }}>Número *</label>
            <input required type="text" name="numero" value={formData.endereco.numero} onChange={(e) => handleChange(e, 'endereco')} style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0' }} />
          </div>
          <div className="form-group">
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#4a5568' }}>Bairro *</label>
            <input required type="text" name="bairro" value={formData.endereco.bairro} onChange={(e) => handleChange(e, 'endereco')} style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0' }} />
          </div>
          <div className="form-group">
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#4a5568' }}>Cidade *</label>
            <input required type="text" name="cidade" value={formData.endereco.cidade} onChange={(e) => handleChange(e, 'endereco')} style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0' }} />
          </div>
          <div className="form-group">
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#4a5568' }}>Estado (UF) *</label>
            <input required type="text" name="estado" value={formData.endereco.estado} onChange={(e) => handleChange(e, 'endereco')} style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0' }} />
          </div>
          <div className="form-group">
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#4a5568' }}>CEP *</label>
            <input required type="text" name="cep" value={formData.endereco.cep} onChange={(e) => handleChange(e, 'endereco')} style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0' }} />
          </div>

          {/* Dados Fiscais */}
          <div style={{ gridColumn: '1 / -1', marginTop: '10px' }}>
            <h3 style={{ fontSize: '16px', color: '#4a5568', borderBottom: '1px solid #e2e8f0', paddingBottom: '8px', marginBottom: '15px' }}>Dados Fiscais</h3>
          </div>
          
          <div className="form-group">
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#4a5568' }}>Razão Social *</label>
            <input required type="text" name="razao_social" value={formData.dados_empresa.razao_social} onChange={(e) => handleChange(e, 'dados_empresa')} style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0' }} />
          </div>
          <div className="form-group">
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#4a5568' }}>CNPJ *</label>
            <input required type="text" name="cnpj" value={formData.dados_empresa.cnpj} onChange={(e) => handleChange(e, 'dados_empresa')} style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0' }} />
          </div>

          {/* Contato */}
          <div style={{ gridColumn: '1 / -1', marginTop: '10px' }}>
            <h3 style={{ fontSize: '16px', color: '#4a5568', borderBottom: '1px solid #e2e8f0', paddingBottom: '8px', marginBottom: '15px' }}>Contato</h3>
          </div>

          <div className="form-group">
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#4a5568' }}>Telefone *</label>
            <input required type="text" name="telefone" value={formData.contato.telefone} onChange={(e) => handleChange(e, 'contato')} style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0' }} />
          </div>
          <div className="form-group">
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#4a5568' }}>Email *</label>
            <input required type="email" name="email" value={formData.contato.email} onChange={(e) => handleChange(e, 'contato')} style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0' }} />
          </div>

          {/* Dados Financeiros */}
          <div style={{ gridColumn: '1 / -1', marginTop: '10px' }}>
            <h3 style={{ fontSize: '16px', color: '#4a5568', borderBottom: '1px solid #e2e8f0', paddingBottom: '8px', marginBottom: '15px' }}>Financeiro</h3>
          </div>

          <div className="form-group">
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#4a5568' }}>Dia de Vencimento (1-31)</label>
            <input 
              type="number" 
              min="1" 
              max="31" 
              name="dia_vencimento" 
              value={formData.financeiro.dia_vencimento} 
              onChange={(e) => handleChange(e, 'financeiro')} 
              style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0' }} 
            />
          </div>
          <div className="form-group">
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#4a5568' }}>Valor Mensalidade (R$)</label>
            <input 
              type="number" 
              min="0"
              step="0.01"
              name="valor_mensalidade" 
              value={formData.financeiro.valor_mensalidade} 
              onChange={(e) => handleChange(e, 'financeiro')} 
              style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0' }} 
            />
          </div>

          {/* Integrador de Estoque */}
          <div style={{ gridColumn: '1 / -1', marginTop: '10px' }}>
            <h3 style={{ fontSize: '16px', color: '#4a5568', borderBottom: '1px solid #e2e8f0', paddingBottom: '8px', marginBottom: '15px' }}>Integrador de Estoque</h3>
          </div>

          <div className="form-group" style={{ gridColumn: '1 / -1' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#4a5568' }}>Tipo de Integrador</label>
            <select
              name="tipo"
              value={formData.integrador.tipo}
              onChange={(e) => handleChange(e, 'integrador')}
              style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0' }}
            >
              <option value="nenhum">Nenhum (sem integração)</option>
              <option value="autocerto">Autocerto</option>
              <option value="manual">Manual (outros integradores - em breve)</option>
            </select>
          </div>

          {formData.integrador.tipo === 'autocerto' && (
            <>
              <div className="form-group" style={{ gridColumn: '1 / -1' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#4a5568' }}>URL de Conexão *</label>
                <input
                  type="url"
                  name="url_conexao"
                  placeholder="https://webapi.autocerto.com/api/integracaocliente/AnunciosJson?token=..."
                  value={formData.integrador.url_conexao}
                  onChange={(e) => handleChange(e, 'integrador')}
                  style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0', fontSize: '13px' }}
                />
                <small style={{ color: '#718096', fontSize: '12px' }}>Cole a URL completa fornecida pelo Autocerto incluindo o token</small>
              </div>

              <div className="form-group">
                <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#4a5568' }}>Taxa de Atualização</label>
                <select
                  name="taxa_atualizacao"
                  value={formData.integrador.taxa_atualizacao}
                  onChange={(e) => handleChange(e, 'integrador')}
                  style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0' }}
                >
                  <option value="manual">Manual (apenas via botão)</option>
                  <option value="hora_em_hora">Hora em hora (6h-22h)</option>
                  <option value="diaria">Diária (escolher horário)</option>
                  <option value="semanal">Semanal (escolher dia e horário)</option>
                </select>
              </div>

              {formData.integrador.taxa_atualizacao === 'diaria' && (
                <div className="form-group">
                  <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#4a5568' }}>Horário de Atualização</label>
                  <input
                    type="time"
                    name="horario_atualizacao"
                    value={formData.integrador.horario_atualizacao}
                    onChange={(e) => handleChange(e, 'integrador')}
                    style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0' }}
                  />
                </div>
              )}

              {formData.integrador.taxa_atualizacao === 'semanal' && (
                <>
                  <div className="form-group">
                    <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#4a5568' }}>Dia da Semana</label>
                    <select
                      name="dia_atualizacao"
                      value={formData.integrador.dia_atualizacao}
                      onChange={(e) => handleChange(e, 'integrador')}
                      style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0' }}
                    >
                      <option value="0">Domingo</option>
                      <option value="1">Segunda-feira</option>
                      <option value="2">Terça-feira</option>
                      <option value="3">Quarta-feira</option>
                      <option value="4">Quinta-feira</option>
                      <option value="5">Sexta-feira</option>
                      <option value="6">Sábado</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#4a5568' }}>Horário de Atualização</label>
                    <input
                      type="time"
                      name="horario_atualizacao"
                      value={formData.integrador.horario_atualizacao}
                      onChange={(e) => handleChange(e, 'integrador')}
                      style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e0' }}
                    />
                  </div>
                </>
              )}

              <div className="form-group" style={{ gridColumn: '1 / -1' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    name="ativo"
                    checked={formData.integrador.ativo}
                    onChange={(e) => setFormData(prev => ({
                      ...prev,
                      integrador: { ...prev.integrador, ativo: e.target.checked }
                    }))}
                    style={{ width: '18px', height: '18px' }}
                  />
                  <span style={{ fontSize: '14px', color: '#4a5568' }}>Ativar sincronização automática</span>
                </label>
                <small style={{ color: '#718096', fontSize: '12px', marginLeft: '26px', display: 'block', marginTop: '4px' }}>
                  O botão "Forçar Atualização" estará disponível independente desta opção
                </small>
              </div>
            </>
          )}

          <div style={{ gridColumn: '1 / -1', display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
            <button type="button" onClick={onClose} style={{ padding: '10px 20px', borderRadius: '6px', border: '1px solid #cbd5e0', background: 'white', cursor: 'pointer' }}>Cancelar</button>
            <button type="submit" disabled={loading} style={{ padding: '10px 20px', borderRadius: '6px', border: 'none', background: '#3182ce', color: 'white', cursor: 'pointer', fontWeight: 'bold' }}>
              {loading ? 'Salvando...' : 'Salvar Loja'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CadastrarLojaModal;